import React, { useState } from 'react';
import { instanceOf, func } from 'prop-types';
import sortBy from 'lodash/sortBy';

import { connect } from 'react-redux';
import TCTreeList from './TCTreeList';
import { updateTc, activateTC } from '../../../actions/turnkeyOmnibusActions';
import TCDragLayer from './TCDragLayer';


const TCTree = ({ tc, updateTc, activateTC }) => {
  const initialState = {
    selectedTc: [],
    selectedNode: {
      last: null,
      current: null,
      qNode: null,
    },
  };

  const [state, setState] = useState(initialState);

  const toggleOpen = item => updateTc(item, 'TOGGLE');

  const rangeNum = (start, end) => Array((end - start) + 1).fill().map((_, idx) => start + idx);

  const getSelectionRange = (last, current) => {
    const [a, b] = sortBy([last, current]);
    const nodeRange = rangeNum(a, b);
    return nodeRange;
  };

  const updateState = (last = null, current = null, qNode = null) => {
    setState({
      ...state,
      selectedTc: [],
      selectedNode: {
        ...state.selectedNode,
        last,
        current,
        qNode,
      },
    });
  };

  const hanldeShiftDown = item => {
    const { selectedNode } = state;
    const hasLastNode = selectedNode.last >= 0 && (selectedNode.qNode === item.qNode);
    const last = hasLastNode ? selectedNode.last : item.oNode;
    const current = item.oNode;
    const qNode = item.qNode;
    updateState(last, current, qNode);
    const range = getSelectionRange(last, current);
    // update to reducer
    updateTc({ qNode, range, isShiftClick: true }, 'SELECTION');
  };

  const hanldeCtrlDown = item => {
    const last = item.oNode;
    const current = item.oNode;
    const qNode = item.qNode;
    updateState(last, current, qNode);
    const range = getSelectionRange(last, current);
    // update to reducer
    updateTc({ qNode, range, isShiftClick: false }, 'SELECTION');
  };

  const childClick = (event, item) => {
    const isCtrlDown = event.ctrlKey || event.metaKey;
    const isShiftDown = event.shiftKey || (event.shiftKey && isCtrlDown);

    // handle shift press for multiple selection
    if (isShiftDown) {
      hanldeShiftDown(item);
    } else if (isCtrlDown) {
      // handle for control clik for multiple selection.
      hanldeCtrlDown(item);
    } else {
      // handle single click.
      updateTc(item, 'CLICK');
      updateState();
    }
  };


  const getSelectedTc = () => {
    const selectedTc = [];
    tc.map(t => {
      t.options.map(op => {
        if (op.isSelected) {
          selectedTc.push(op);
        }
        return false;
      });
      return false;
    });
    return selectedTc;
  };

  const onDrag = dragNode => {
    let selectedTc = [dragNode];
    if (getSelectedTc().length > 0) {
      selectedTc = getSelectedTc();
    }
    setState({
      ...state,
      selectedTc,
    });
  };

  const onDrop = () => {
    activateTC(state.selectedTc);
  };

  const funcs = {
    toggleOpen,
    childClick,
    onDrag,
    onDrop,
  };

  return (
    <div className="ie--tree">
      {state.selectedTc.length > 0 && <TCDragLayer items={state.selectedTc} />}
      <TCTreeList tree={tc} funcs={funcs} canDrag={false} />
    </div>
  );
};

TCTree.propTypes = {
  tc: instanceOf(Array),
  updateTc: func,
  activateTC: func,
};

TCTree.defaultProps = {
  tc: [],
};

const mapStateToProps = ({ turnkeyOmnibus }) => {
  const { targetingCriteria } = turnkeyOmnibus;
  return {
    tc: targetingCriteria.data,
  };
};

export default connect(
  mapStateToProps,
  { updateTc, activateTC }
)(TCTree);
